import React from 'react';
import PropTypes from 'prop-types';
import CsvImportFileSelector from './CsvImportFileSelector.jsx';
import { saveTextAs } from '../../../../Common/Utilities/FileUtilities';
import { upperCaseFirstLetter } from '../../../../Common/Utilities/StringUtilities';
import LoadingSpinnerView from "../../../Components/LoadingSpinnerView";

class SelectFileView extends React.PureComponent
{
    render() {
        return <div className="segment" data-component="SelectFileView">
            <ol>
                <li>
                    <h3>1. Prepare your { this.props.nameOfObjectToImport } file</h3>
                    {
                        this.props.exportUrl && this.props.exportPageName
                            ? <p>Updating and using existing { this.props.nameOfObjectToImport }? Go to the <a href={ this.props.exportUrl } target="_blank" onMouseUp={ this.registerLinkClicked }>View { this.props.nameOfObjectToImport }</a> page and export your current { this.props.nameOfObjectToImport } to a CSV (comma separated value) file.</p>
                            : null
                    }
                    <p>
                        {
                            this.props.exportUrl && this.props.exportPageName
                            ? `No ${ this.props.nameOfObjectToImport } in eCargo? `
                            : null
                        }
                        Use our <button type="button" className="download link button" onClick={ this.onDownloadTemplate }>{ this.props.nameOfObjectToImport } CSV template file.</button></p>

                    {
                        this.props.isTemplateFileDownloading ?
                            <div className="inline">
                                <LoadingSpinnerView text="Downloading template file..." inline={true}/>
                            </div> : null
                    }

                </li>

                <CsvImportFileSelector nameOfObjectToImport={ this.props.nameOfObjectToImport } file={ this.props.file } onUploadRequested={ this.props.onUploadRequested } onFileSelected={ this.props.onFileSelected } />

                <li>
                    <h3>Hints</h3>
                    <p>Your file needs to be in CSV format.</p>
                    <p>Import file column names need to match the downloaded { this.props.nameOfObjectToImport } file or template file.</p>
                    <p>{ upperCaseFirstLetter(this.props.nameOfObjectToImport) } detail names need to exactly match the existing master data in eCargo - e.g. customer names, carrier names, etc.</p>
                    <p>Need help? More detailed information is available on <a href={ this.props.helpUrl } target="eCargo Help">our online help page</a>.</p>
                </li>
            </ol>
        </div>
    }

    onDownloadTemplate = () => {
        const objectName = upperCaseFirstLetter(this.props.nameOfObjectToImport);
        if(typeof this.props.sampleCsvFile === "function") {
            this.props.sampleCsvFile();
        }
        else {
            saveTextAs(this.props.sampleCsvFile, `${objectName}Template.csv`, 'text/csv');
        }
    };
};

SelectFileView.propTypes = {
    file: PropTypes.object,
    onUploadRequested: PropTypes.func.isRequired,
    onFileSelected: PropTypes.func.isRequired,
    nameOfObjectToImport: PropTypes.string.isRequired,
    exportUrl: PropTypes.string,
    exportPageName: PropTypes.string,
    sampleCsvFile: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
    helpUrl: PropTypes.string.isRequired,
    isTemplateFileDownloading: PropTypes.bool
}

export default SelectFileView;
